module.exports = __webpack_public_path__ + "img/china_mobile_icon.b57b1c55.svg";